import React, { useReducer, useMemo, useState } from 'react'
import { Form, Divider, Button, Icon } from 'semantic-ui-react'
import { maskCurrency, useSubscription } from 'utils'
import InputMask from 'react-input-mask'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { toast } from 'react-toastify'

function inputsReducer(state, action) {
    if ('reset' in action)
        return {}
    if(!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function InputsForm({ inputs, setInputs, eventos, form, setForm, handleChange }) {

    const init = eventos.map(
        it => ({ 
            key: it.id, 
            value: inputs.find(that => that.id === it.id) && inputs.find(that => that.id === it.id).value ? 
                inputs.find(that => that.id === it.id).value : '' 
        })
    ).reduce((obj, v) => {
        obj[v.key] = v.value
        return obj
    }, {})

    const [formInputs, setFormInputs] = useReducer(inputsReducer, init)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const submitEventos$ = useMemo(() =>  request({
        url: '/departamento-pessoal/eventos',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: { 
            ...form, 
            eventos: {
                ...Object.keys(formInputs).filter(it => formInputs[it] !== "" && inputs.map(x => x.id).includes(it)).reduce((obj, key) => {
                    obj[key] = formInputs[key]
                    return obj
                }, {})
            } 
        }
    }).pipe(
        tap(() => {
            toast.success('Dados salvos!')
            setForm({ payload: { funcionario: '' } })
            setInputs([])
        }),
        finalize(() => setIsSubmitting(false))
    ), [formInputs, form, inputs, setForm, setInputs])

    useSubscription(submitEventos$, isSubmitting)

    function handleInputsChange(event, props) {
        let name, value
        if (!props)
            [name, value] = [event.target.name, event.target.value]
        else {
            name = props.name
            value = maskCurrency(props.value)
        }
        setFormInputs({ payload: { [name]: value } })
    }

    function mountInput(input) {
        if (/horas/i.test(input.placeholder)) {
            return (
                <InputMask mask="99:99" {...input} value={formInputs[input.id]} onChange={handleInputsChange}>
                    {inputProps => <Form.Input width='5' {...inputProps} />}
                </InputMask>
            )
        } else if (/%/i.test(input.placeholder)) {
            return (
                <InputMask mask="999,99" {...input} value={formInputs[input.id]} onChange={handleInputsChange}>
                    {inputProps => <Form.Input width='5' {...inputProps} />}
                </InputMask>
            )
        } else if (/dias/i.test(input.placeholder)) {
            return (
                <InputMask mask="99" {...input} value={formInputs[input.id]} onChange={handleInputsChange}>
                    {inputProps => <Form.Input width='5' {...inputProps} />}
                </InputMask>
            )
        } else {
            return (
                <Form.Input width='5' {...input} value={formInputs[input.id]} onChange={handleInputsChange} />
            )
        }
    }

    function handleSubmit() {
        if (!(!!form.empresa) || !(!!form.periodo) || !(!!form.funcionario) || Object.keys(formInputs).filter(it => formInputs[it] !== "").length === 0) {
            toast.error('Por favor, preencha os dados acima e pelo menos um evento antes de salvar.')
        } else 
            setIsSubmitting(true)
    }   

    return (
        <Form size='tiny' className='mt-2' onSubmit={handleSubmit} loading={isSubmitting} noValidate>
            {inputs.length > 0 && new Array(Math.ceil(inputs.length / 3)).fill(null).map((_, index) =>
                <Form.Group key={index}>
                    {inputs.filter((_, idx) => (idx <= (index + 2) && index === 0) || (idx >= (index * 3) && idx <= (index * 3 + 2) && index > 0))
                        .map((input, idx) =>
                            <React.Fragment key={idx}>
                                {mountInput(input)}
                            </React.Fragment>
                        )}
                </Form.Group>
            )}

            <Divider className='my-2 custom-divider darken' fitted />

            <Form.Input width='6' label='Observações' name='observacao' placeholder='Informe alguma observação' value={form.observacao} onChange={handleChange} autoComplete="off" />

            <Button className='mt-2' size='tiny' floated='right' icon labelPosition='left' disabled={isSubmitting} color='green'>
                <Icon name='arrow right' /> Salvarrr
            </Button>

        </Form>
    )
}
